/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-15 14:57:17
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-17 17:39:07
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/DraggableModules/ContentGroup/ModulesGenerator/ArticleCarousel.ts
 */
import { ActionType } from 'src/types/common/common';
import { generateNewContentImg } from 'src/constrains/DraggableModules/tools';
import {
  //ProductList,
  //   LongCanvas,
  //   Text,
  //   Poster,
  //   ProductGridDisplay,
  CarouselAdaptor,
  //   ListAdaptor,
} from 'src/constrains/DraggableModules/Components';

const ArticleCarouselFunctions = ({
  onDynamicChange,
  onStaticChange,
  onModuleTypeChange,
}) => {
  const handleOnCarouselItemAdd = (id) => {
    const _o = generateNewContentImg();
    if (onDynamicChange) {
      onDynamicChange({ type: ActionType.add, id, data: [_o] });
    }
  };

  const handleOnCarouselItemDelete = (id, index) => {
    if (onDynamicChange) {
      onDynamicChange({ type: ActionType.delete, id, data: { index } });
    }
  };

  const handleOnCarouselItemChange = (id, index, modifiedData) => {
    if (onDynamicChange) {
      onDynamicChange({
        type: ActionType.modify,
        id,
        data: {
          index,
          modifiedData,
        },
      });
    }
  };

  const handleOnCarouselItemSort = (id, from, to) => {
    if (onDynamicChange) {
      onDynamicChange({
        type: ActionType.reorder,
        id,
        data: {
          from,
          to,
        },
      });
    }
  };

  const handleOnCarouselStaticChange = (id, data) => {
    if (onStaticChange) {
      onStaticChange({
        type: ActionType.modify,
        id,
        data,
      });
    }
  };

  const handleOnCarouselModuleTypeChange = (data) => {
    if (onModuleTypeChange) {
      onModuleTypeChange(data);
    }
  };
  return {
    handleOnCarouselItemAdd,
    handleOnCarouselItemDelete,
    handleOnCarouselItemChange,
    handleOnCarouselItemSort,
    handleOnCarouselStaticChange,
    handleOnCarouselModuleTypeChange,
  };
};
const generateArticleCarousel = ({
  onDynamicChange,
  onStaticChange,
  onModuleTypeChange,
}) => {
  const {
    handleOnCarouselItemAdd,
    handleOnCarouselItemDelete,
    handleOnCarouselItemChange,
    handleOnCarouselItemSort,
    handleOnCarouselStaticChange,
    handleOnCarouselModuleTypeChange,
  } = ArticleCarouselFunctions({
    onDynamicChange,
    onStaticChange,
    onModuleTypeChange,
  });
  return {
    component: CarouselAdaptor,
    props: {
      onItemAdd: handleOnCarouselItemAdd,
      onItemChange: handleOnCarouselItemChange,
      onItemSort: handleOnCarouselItemSort,
      onItemDelete: handleOnCarouselItemDelete,
      onStaticChange: handleOnCarouselStaticChange,
      onModuleTypeChange: handleOnCarouselModuleTypeChange,
    },
  };
};
export { generateArticleCarousel };
